
export const userRolesUtil = (data) => {
    return data.map(item => {
        return item.IDMenu
    })
}